import { useAcl } from "vue-simple-acl";
import { ACLRoles } from "~/core/models/ACLRoles.enum";

const { can } = useAcl();

export function canManageThirdPartyApps() {
  return can(ACLRoles.CAN_WRITE_APPLICATION);
}
